import { render, staticRenderFns } from "./success-message.vue?vue&type=template&id=e064be3c"
import script from "./success-message.vue?vue&type=script&lang=js"
export * from "./success-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports